import "@/assets/scss/talent/components/publicprofile.scss";
import { trackPublicProfile } from "./tracking";
import { DEFAULT_COMPANY_COLOR } from "./constants";

// Utilidades comuns das telas do perfil publico.
export default {
  computed: {
    companyColor() {
      const company = this.$store.state.company.company || {};
      const color = company.base_hexcolor;
      if (!color || String(color).toLowerCase() === "#ffffff") return DEFAULT_COMPANY_COLOR;
      return color;
    },
    companyLabel() {
      return (this.$route && this.$route.params.company_label) || "";
    },
  },
  methods: {
    // Evento do perfil publico com o retrato do perfil (plano, modelo, secoes...).
    // `setPerson` grava plano/modelo/link na pessoa do PostHog, para coorte.
    ppTrack(event, props = {}, options = {}) {
      const context = this.companyLabel ? { company_label: this.companyLabel } : {};
      trackPublicProfile(this.$store.state.publicProfile, event, { ...context, ...props }, options);
    },
    ppNotify(text, color = "success", title = "") {
      this.$vs.notify({
        title,
        text,
        color,
        iconPack: "feather",
        icon: color === "success" ? "icon-check" : color === "danger" ? "icon-alert-circle" : "icon-info",
        position: "top-center",
      });
    },
    ppError(text = "Não foi possível concluir agora. Tente de novo em instantes.") {
      this.ppNotify(text, "danger", "Ops!");
    },
  },
};
